// ── Direct bookings on the calendars (2026-08) ──────────────────────────────
// THE single mapper from a calendar endpoint's additive `direct_bookings`
// item to the pseudo-request shape the shared week grid + month grid already
// render. BOTH portals (NetworkScheduling + ClinicScheduling) import this —
// never a local copy (statically pinned, same doctrine as the shared grids).
//
// id is prefixed ("db-…") so it can never collide with a numeric request id.
// status "direct_booking" drives the distinct indigo treatment + "Direct"
// label in both grids; the single time has source "direct" so the clinic
// grid's confirmable() (source === "weststar") can never offer a slot pick.
export function directBookingToCalendarItem(b) {
  return {
    id: `db-${b.id}`,
    type: "direct_booking",
    status: "direct_booking",
    patient_id: b.patient_id,
    patient_name: b.patient_name,
    location_code: b.location_code,
    appointment_type: b.appointment_type,
    booking: b,
    proposed_times: [
      {
        id: 0,
        date: b.date,
        start_time: b.start_time,
        end_time: b.end_time,
        is_confirmed: true,
        source: "direct",
      },
    ],
  };
}

// One merge point for both fetches: existing requests untouched, direct
// bookings appended as distinct items.
export function mergeCalendarItems(data) {
  return [
    ...(data?.requests || []),
    ...(data?.direct_bookings || []).map(directBookingToCalendarItem),
  ];
}
